/* unplugin-vue-components disabled */import { render } from "./awesomeIcon.vue?vue&type=template&id=6fc49362"
import script from "./awesomeIcon.vue?vue&type=script&lang=js"
export * from "./awesomeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__